export const varizhaReducer = (state = [], action) => {
    switch (action.type) {
        case "VRZHA":
            return [...action.payload];
        default:
            return state;
    }
};
